import ICurrentMenuItem from "../models/ICurrentMenuItem";
import QmlativDocsMenu from "../models/QmlativDocsMenu";
import SMSDocsMenu from "../models/SMSDocsMenu";
import { isDocMenuItemSelected } from "./isDocMenuItemSelected";

export const getCurrentDocMenuItem = (): ICurrentMenuItem | null => {
  const menus = [
    { product: "Qmlativ", menu: QmlativDocsMenu },
    { product: "SMS 2.0", menu: SMSDocsMenu },
  ];
  for (let i = 0; i < menus.length; i++) {
    const { product, menu } = menus[i];
    for (let j = 0; j < menu.length; j++) {
      const { title, items } = menu[j];
      if (items) {
        for (let k = 0; k < items.length; k++) {
          const item = items[k];
          if (isDocMenuItemSelected(item)) {
            return {
              product,
              title,
              item,
            };
          }
        }
      }
    }
  }
  return null;
};
